export default __webpack_public_path__ + "static/media/origon.7e2ea66e.png";